import EventEmitter from 'events';
import {
    Vector3,
    PerspectiveCamera,
    Vector2,
    Raycaster,
    Plane
} from 'three';


//Class that manage hovering on particles scene;
export default class InteractiveControls extends EventEmitter {
    public camera : any;
    public el : any;
    public raycaster : any;
    public mouse : any;
    public offset : any;
    public intersection : any;
    public objects : any;
    public hovered : any;
    public selected : any;
    public isDown : any;
    public enabled : any;
    public rect : any;
    public intersectionData : any;
    public plane : any;
    public handlerDown : any;
    public handlerMove : any;
    public handlerUp : any;
    public handlerLeave : any;

    constructor(camera : PerspectiveCamera | undefined, el : any, target : HTMLElement) {
        super();

        this.el = el || window;
        this.camera = new PerspectiveCamera(100, target.clientWidth / target.clientHeight, 1, 10000);
        this.camera.position.z = 300;
        this.raycaster = new Raycaster();
        let cameraEl = new PerspectiveCamera(100, target.clientWidth / target.clientHeight, 1, 10000);
        cameraEl.position.z = 300;
        this.raycaster.camera = cameraEl;

        this.plane = new Plane();
        this.mouse = new Vector2();
        this.offset = new Vector3();
        this.intersection = new Vector3();

        this.objects = [];
        this.hovered = null;
        this.selected = null;

        this.isDown = false;

        this.enable();
        this.resize();
    }

    enable() {
        this.addListeners();
        this.enabled = true;
    }


    disable() {
        if (!this.enabled) return;
        this.removeListeners();
        this.enabled = false;
    }

    addListeners() {
        this.handlerDown = this.onDown.bind(this);
        this.handlerMove = this.onMove.bind(this);
        this.handlerUp = this.onUp.bind(this);
        this.handlerLeave = this.onLeave.bind(this);

        if (window.innerWidth >= 992) {
            this.el.addEventListener('mousedown', this.handlerDown);
            this.el.addEventListener('mousemove', this.handlerMove);
            this.el.addEventListener('mouseup', this.handlerUp);
            this.el.addEventListener('mouseleave', this.handlerLeave);
        }
    }

    removeListeners() {
    }

    resize(x = null, y = null, width = null, height = null) {
        if (x || y || width || height) {
            this.rect = { x, y, width, height };
        }
        else if (this.el === window) {
            this.rect = { x: 0, y: 0, width: window.innerWidth, height: window.innerHeight };
        }
        else {
            this.rect = this.el.getBoundingClientRect();
        }
    }

    onMove(e : any) {
        const t = (e.touches) ? e.touches[0] : e;
        const touch = { x: t.offsetX, y: t.offsetY };

        this.mouse.x = (touch.x / this.rect.width) * 2 - 1;
        this.mouse.y = -(touch.y / this.rect.height) * 2 + 1;

        this.raycaster.setFromCamera(this.mouse, this.camera);

        const intersects = this.raycaster.intersectObjects(this.objects);

        if (intersects.length > 0) {
            const object = intersects[0].object;
            this.intersectionData = intersects[0];

            this.plane.setFromNormalAndCoplanarPoint(this.camera.getWorldDirection(this.plane.normal), object.position);

            if (this.hovered !== object) {
                this.emit('interactive-out', { object: this.hovered });
                this.emit('interactive-over', { object });
                this.hovered = object;
            }
            else {
                this.emit('interactive-move', { object, intersectionData: this.intersectionData });
            }
        }
        else {
            this.intersectionData = null;

            if (this.hovered !== null) {
                this.emit('interactive-out', { object: this.hovered });
                this.hovered = null;
            }
        }
    }

    onDown(e : any) {
        this.onMove(e);

        this.emit('interactive-down', { object: this.hovered, previous: this.selected, intersectionData: this.intersectionData });
        this.selected = this.hovered;

        if (this.selected) {
            if (this.raycaster.ray.intersectPlane(this.plane, this.intersection)) {
                this.offset.copy(this.intersection).sub(this.selected.position);
            }
        }
    }

    onUp() {
        this.isDown = false;

        this.emit('interactive-up', { object: this.hovered });
    }

    onLeave() {
        this.onUp();

        this.emit('interactive-out', { object: this.hovered });
        this.hovered = null;
    }
}
